const { __ } = wp.i18n;

window.addEventListener('DOMContentLoaded', () => {
	const headerEl = document.querySelector('.wp-block-mavis-header-content');

	const mobileMenuToggle = document.querySelector('.mavisHeader_menuToggle.is-mobile');
	const hiddenMobileNavEls = document.querySelector('.mavisHeader_mobileNavs');
	const mobileFocusableElements = [...hiddenMobileNavEls.querySelectorAll('li')];
	const mobileLastFocusableElement = mobileFocusableElements[mobileFocusableElements.length - 1];

	const searchBtn = document.querySelector('.mavisHeader_searchButton');
	const menuToggle = document.querySelector('.mavisHeader_menuToggle.is-tabletDesktop');
	const hiddenSearchEl = document.querySelector('.mavisHeader_bottom-search');
	const searchLastFocusableElement = hiddenSearchEl.querySelector(
		'button[type="submit"].wp-block-search__button',
	);

	const menuDropdownDesktop = document.querySelector('.mavisHeader_bottom-dropdownMenu');
	const dropdownMenuContainer = menuDropdownDesktop.querySelector(
		'.mavisHeader_bottom-dropdownMenu-menu',
	);
	const desktopLastFocusableElement = menuDropdownDesktop.querySelector('li:last-of-type');

	const body = document.querySelector('body');

	const isReduced =
		window.matchMedia(`(prefers-reduced-motion: reduce)`) === true ||
		window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;

	/**
	 * Determines what the toggle button text should be updated to.
	 * @param {Element} el - Toggle button text element.
	 * @returns {string}
	 */
	const toggleText = (el) =>
		el.innerHTML.includes('Menu') ? __('Close', 'mavis') : __('Menu', 'mavis');

	/**
	 * Determines what the toggle button aria-label should be based on the header element state.
	 * @returns {string}
	 */
	const toggleAriaLabel = () =>
		headerEl.classList.contains('is-open') ? __('close menu', 'mavis') : __('open menu', 'mavis');

	/**
	 * Handles the event of a menu toggle click
	 * @param {Element} toggleEl Menu toggle that was clicked.
	 */
	const handleToggleClick = (toggleEl, navsToShow) => {
		const toggleTextEl = toggleEl.querySelector('p');
		// Slight delay on the text change to sync better with the CSS transitions.
		const timeoutDuration = isReduced ? '0' : '100';
		setTimeout(() => {
			toggleTextEl.innerHTML = toggleText(toggleTextEl);
		}, timeoutDuration);
		headerEl.classList.toggle('is-open');
		toggleEl.setAttribute('aria-label', toggleAriaLabel());
		navsToShow.toggleAttribute('inert');
	};

	/**
	 * Creates a focus trap for mobile menu
	 * @param {event} e keydown event
	 * @param {Element} toggleToFocus the first element for the focus to loop back to
	 */
	const createFocusTrap = (e, toggleToFocus) => {
		const isTabPressed = e.key === 'Tab';

		if (!isTabPressed) {
			return;
		}
		// Shift focus to the first element to give looping effect
		if (isTabPressed && !e.shiftKey) {
			toggleToFocus.focus();
			e.preventDefault();
		}
	};

	/**
	 * Adds a class to the menu toggle when tabbing through the menu.
	 * @param {event} e keydown or click event
	 */
	const addClassToMenuWhenTabbing = (e) => {
		if (e.type === 'keydown') {
			menuToggle.classList.add('focus');
		}
		if (e.type === 'click' && menuToggle.classList.contains('focus')) {
			menuToggle.classList.remove('focus');
		}
	};

	/**
	 * Handles the 'Search' toggle on desktop being clicked.
	 */
	const handleSearchToggleClick = (e) => {
		if (e.type === 'keydown' && e.key !== 'Enter') {
			return;
		}
		e.preventDefault();

		// Highlight the close button if tabbed through but don't when clicked.
		addClassToMenuWhenTabbing(e);

		const toggleTextEl = document.querySelector('.mavisHeader_searchButton p');
		const wasClosed = toggleTextEl.innerHTML.includes('Search');
		const searchInputEl = hiddenSearchEl.querySelector('input[type="search"]');
		const menuToggleText = document.querySelector('.mavisHeader_menuToggle.is-tabletDesktop p');
		const menuOpen = menuDropdownDesktop.getAttribute('aria-expanded');

		// if the more menu is open close it but don't change button text
		if (menuOpen === 'true') {
			menuDropdownDesktop.setAttribute('aria-expanded', 'false');
		}

		menuToggleText.innerHTML = __('Close', 'mavis');

		hiddenSearchEl.removeAttribute('inert');

		hiddenSearchEl.setAttribute('aria-expanded', 'true');

		searchBtn.setAttribute(
			'aria-label',
			wasClosed ? __('close search', 'mavis') : __('open search', 'mavis'),
		);
		headerEl.classList.add('is-open');

		if (e.type === 'keydown' && wasClosed) {
			searchInputEl.focus();
		}
	};

	/**
	 * Handles the 'Menu' toggle on desktop being clicked.
	 */
	const handleMenuToggleClick = (e) => {
		if (e.type === 'keydown' && e.key !== 'Enter') {
			return;
		}
		e.preventDefault();

		// Highlight the close button if tabbed through but don't when clicked.
		addClassToMenuWhenTabbing(e);
		const menuToggleText = document.querySelector('.mavisHeader_menuToggle.is-tabletDesktop p');
		const searchOpen = document.querySelector(
			'.mavisHeader_searchButton[aria-label="close search"]',
		);

		// Open menu if search isn't open
		if (!searchOpen) {
			const expanded = menuDropdownDesktop.getAttribute('aria-expanded') === 'true' || false;
			menuDropdownDesktop.setAttribute('aria-expanded', !expanded);
			menuDropdownDesktop.removeAttribute('inert');
		}

		// If search is open close it
		if (searchOpen) {
			searchBtn.setAttribute('aria-label', __('open search', 'mavis'));
			hiddenSearchEl.setAttribute('inert', '');
			hiddenSearchEl.setAttribute('aria-expanded', 'false');
		}

		const wasClosed = menuToggleText.innerHTML.includes('More');
		menuToggleText.innerHTML = wasClosed ? __('Close', 'mavis') : __('More', 'mavis');
		headerEl.classList.toggle('is-open');

		if (!headerEl.classList.contains('is-open')) {
			menuDropdownDesktop.setAttribute('inert', '');
		}
	};

	mobileMenuToggle.addEventListener('click', () => {
		handleToggleClick(mobileMenuToggle, hiddenMobileNavEls);
	});

	mobileLastFocusableElement.addEventListener('keydown', (e) =>
		createFocusTrap(e, mobileMenuToggle),
	);

	searchLastFocusableElement.addEventListener('keydown', (e) => createFocusTrap(e, searchBtn));
	desktopLastFocusableElement.addEventListener('keydown', (e) => createFocusTrap(e, menuToggle));

	searchBtn.addEventListener('click', (e) => handleSearchToggleClick(e));
	searchBtn.addEventListener('keydown', (e) => {
		handleSearchToggleClick(e);
	});

	menuToggle.addEventListener('click', (e) => handleMenuToggleClick(e));
	menuToggle.addEventListener('keydown', (e) => {
		handleMenuToggleClick(e);
	});

	body.addEventListener('keydown', (e) => {
		const openMenu = document.querySelector('.wp-block-mavis-header-content.is-open');
		if (e.key !== 'Escape' || !openMenu) {
			return;
		}
		addClassToMenuWhenTabbing(e);
		if (window.innerWidth < 720) {
			handleToggleClick(mobileMenuToggle, hiddenMobileNavEls);
			mobileMenuToggle.focus();
		} else {
			handleSearchToggleClick(e);
			menuToggle.focus();
		}
	});

	/**
	 * Sets the padding-top of the collapsible regions depending on the height of the header content.
	 */
	const setCollapsibleRegionPaddingTop = () => {
		if (window.innerWidth >= 720) {
			hiddenSearchEl.style.paddingTop = `calc(2rem + ${headerEl.offsetHeight}px + 2rem)`;
			dropdownMenuContainer.style.paddingTop = `calc(2rem + ${headerEl.offsetHeight}px + 2rem)`;
		} else {
			hiddenMobileNavEls.style.paddingTop = `calc(2rem + ${headerEl.offsetHeight}px + 2rem)`;
			dropdownMenuContainer.style.paddingTop = `calc(2rem + ${headerEl.offsetHeight}px + 2rem)`;
		}
	};

	// Closes the collapsible sections if the window is resized out of their range.
	// Disabling eslint complexity rule as we need to check these set conditions here.
	/* eslint-disable complexity */
	window.addEventListener('resize', (e) => {
		if (
			window.innerWidth >= 720 &&
			mobileMenuToggle.getAttribute('aria-label') === 'close menu' &&
			headerEl.classList.contains('is-open')
		) {
			handleToggleClick(mobileMenuToggle, hiddenMobileNavEls);
		} else if (
			window.innerWidth < 720 &&
			searchBtn.getAttribute('aria-label') === 'close search' &&
			headerEl.classList.contains('is-open')
		) {
			hiddenSearchEl.style.paddingTop = `calc(2rem + ${headerEl.offsetHeight}px + 2rem)`;
			handleSearchToggleClick(e);
		}
		setCollapsibleRegionPaddingTop();
	});
	/* eslint-enable complexity */

	setCollapsibleRegionPaddingTop();
});
